import { AnalyticsBrowser } from "@segment/analytics-next";

import type { Environment } from "./environment";

export const SEGMENT_WRITE_KEY_BY_ENVIRONMENT: Record<
  Environment,
  string | undefined
> = {
  production: "VITE_PRODUCTION_SEGMENT_WRITE_KEY",
  sandbox: "VITE_SANDBOX_SEGMENT_WRITE_KEY",
  development: "VITE_DEVELOPMENT_SEGMENT_WRITE_KEY",
  "review-app": undefined,
};

// See https://github.com/segmentio/analytics-next/tree/master/packages/browser#readme
export const analytics = new AnalyticsBrowser();
